// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Deposit account types'"></sub-header>
  <div>
    <a class="pull-right btn btn-primary"
       command-access="CreateAccountType"
       ng-href="#!/admin/deposit-accounts/types/create">
      Create new
    </a>
    <dynamic-list
      columns="\$ctrl.columns"
      data="\$ctrl.accounts"
      sorting="\$ctrl.sorting">
    </dynamic-list>

    <div ng-if="\$ctrl.accounts.length == 0" class="empty-message">
      <span>No deposit accounts found.</span>
    </div>

    <div class="buttons">
      <button class="btn btn-warning" ng-click="\$ctrl.goBack()">Back</button>
    </div>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/deposit-account/list/deposit-account-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;